import { ValidateParams } from './validateParams'
import { nearMissForm } from "constants/forms/newNearMissForm";
import { newAcidenteForm } from "constants/forms/newAcidenteForm";
import { newUSerForm } from 'constants/forms/user';

export function Validate(formData, resource) {
    return true
    const variables = {
        nearmisses: nearMissForm,
        acidente: newAcidenteForm,
        boaspraticas: nearMissForm,
        user: newUSerForm
    }

    const required = variables[resource]().filter(x => x.required === true)

    for (let i = 0; i < required.length; i++) {
        const valid = ValidateParams(required[i].type, formData[required[i].fieldId])
        if (!valid) {
            return required[i].label
        }
    }

    // return true
}